import AlertPanel from 'ext-ui/components/AlertPanel/AlertPanel'
import AlertCircleIcon from 'ext-ui/svg/icon/AlertCircleIcon'
import React, { ReactElement, ReactNode } from 'react'
import style from 'src/feature/PhysicalCardHomepageError/PhysicalCardHomepageError.style'
import { useTranslate } from 'src/localization/Trns'

type LinkRenderProps = {
  className: string
  'aria-label': string
  children: ReactNode
}

type PhysicalCardHomepageErrorProps = {
  className?: string
  renderLink: (linkProps: LinkRenderProps) => ReactElement
}

function PhysicalCardHomepageError(
  props: PhysicalCardHomepageErrorProps,
): ReactElement {
  const { className = '', renderLink } = props
  const translate = useTranslate()

  return (
    <AlertPanel variant="severe-wcag" className={className}>
      <div className="PhysicalCardHomepageError" css={style}>
        <div className="icon-column">
          <AlertCircleIcon />
        </div>
        <div className="content-column">
          <p className="title">{translate('Error connecting your card')}</p>
          <p>
            {translate('Please try to ')}
            {renderLink({
              className: 'link',
              'aria-label': translate('connect your card again'),
              children: translate('connect'),
            })}
            {translate(' your card again')}
          </p>
        </div>
      </div>
    </AlertPanel>
  )
}

export default PhysicalCardHomepageError
